import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { OutboundDocumentAPI } from '../api/outboundDocument.ts';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { Toast } from '../types/models';
import { OUTBOUND_DOCUMENTS_KEY } from '../queryHooks/outboundDocument.ts';
import { OUTBOUND_DOCUMENT_STATUS_QUERY_KEY } from '../queryHooks/outboundDocumentStatus.ts';

const useUpdateResendOneById = (
  options?: UseMutationOptions<
    Toast | null,
    unknown,
    OutboundDocumentAPI.Request.UpdateResendOneById
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [endpoints.outboundDocument.update.resend.one.by.id()],
    mutationFn: api.outboundDocument.update.resend.one.by.id,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [OUTBOUND_DOCUMENTS_KEY],
      });

      queryClient.invalidateQueries({
        queryKey: [OUTBOUND_DOCUMENT_STATUS_QUERY_KEY],
      });
    },
    ...options,
  });
};

export default {
  useUpdateResendOneById,
};
